import { toast as r } from "@systemeio/ui";
import { createHttpClient as o, getUseBaseFetch as s, getErrorMapper as n } from "@systemeio/util";
import { useTranslation as a } from "../i18n.mjs";
const t = o();
t.interceptors.response.use((e) => e, n(t));
const u = s({
  httpClient: t,
  useLocoTranslation: a,
  useRouter: () => ({
    push: async (e) => (window.location.assign(e), !0),
    replace: async (e) => (window.location.replace(e), !0)
  }),
  toast: r
});
export {
  t as httpClient,
  u as useFetch
};
